import { render, staticRenderFns } from "./ResourceManage.vue?vue&type=template&id=0db2c3c4&scoped=true"
import script from "./ResourceManage.vue?vue&type=script&lang=js"
export * from "./ResourceManage.vue?vue&type=script&lang=js"
import style0 from "./ResourceManage.vue?vue&type=style&index=0&id=0db2c3c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db2c3c4",
  null
  
)

export default component.exports